import React from "react";
import { useNavigate } from "react-router-dom";
import { createSmsPackage } from "src/actions/callrecorder/smsPackagesActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, SmsPackageInterface } from "src/store/callrecorder/smsPackagesSlice";

import Form from './_partials/_Form';
import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";

const New = () => {
  const navigate = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.callrecorder.smsPackages.newParams);
  const error = useAppSelector(state => state.callrecorder.smsPackages.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: SmsPackageInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createSmsPackage(data));

    if (createSmsPackage.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-sms-package'>
        <h6 className="v-content-label">Create Package</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
